import { render, staticRenderFns } from "./SYBuyDetail.vue?vue&type=template&id=5cacf56f&"
import script from "./SYBuyDetail.vue?vue&type=script&lang=js&"
export * from "./SYBuyDetail.vue?vue&type=script&lang=js&"
import style0 from "./SYBuyDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports